import {
  Box,
  chakra,
  Container,
  Link,
  SimpleGrid,
  Stack,
  Text,
  VisuallyHidden,
  Input,
  Button,
  IconButton,
  useColorModeValue,
  HStack,
} from '@chakra-ui/react';
import { BsFillTelephoneFill } from "react-icons/bs"
import { BsFillEnvelopeFill } from "react-icons/bs"
import LogoMP from "./static/img/logo2.png";
import { ReactNode } from 'react';
import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { BiMailSend } from 'react-icons/bi';

import styled from 'styled-components';
import './static/css/index.css'


const ImageCard = styled.img`
    width: 50px;
    object-fit: cover;
    border-radius: 50px;

    @media screen and (max-width: 600px){
      margin-left: 10px;
   }
`;

const SocialButton = ({
  children,
  label,
  href,
}) => {
  return (
    <chakra.button
      bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
      rounded={'full'}
      w={8}
      h={8}
      cursor={'pointer'}
      as={'a'}
      href={href}
      display={'inline-flex'}
      alignItems={'center'}
      justifyContent={'center'}
      transition={'background 0.3s ease'}
      _hover={{
        bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
      }}>
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

const ListHeader = ({ children }) => {
  return (
    <Text fontWeight={'500'} fontSize={'lg'} mb={2}>
      {children}
    </Text>
  );
};

export default function LargeWithNewsletter() {
  return (
    <Box
      bg={useColorModeValue('#6554C0')}
      color={useColorModeValue('gray.700', 'gray.200')}>
      <Container as={Stack} maxW={'100%'} py={10}>
        <SimpleGrid
          color={'#FFFFFF'}
          fontFamily={'Inter'}
          className='grid3'
          templateColumns={{ sm: '3fr 3fr', md: '2fr 1fr 1fr 2fr' }}
          spacing={20}>
          <Stack spacing={6}>
              <HStack marginTop={'-5px'}>
                <ImageCard src={LogoMP} />
                <Text fontFamily= {'Inter'} fontWeight={500}> MagangPro</Text>
              </HStack>
            <Text fontSize={'sm'}>
              We value loyalty to our customer, openness to new ideas, value-creation for our customer 
              through our services, and enthusiasm in working with our stakeholders.
            </Text>
            <Stack direction={'row'} spacing={6}>
              <SocialButton label={'Twitter'} href={'#'}>
                <FaTwitter />
              </SocialButton>
              <SocialButton label={'YouTube'} href={'#'}>
                <FaYoutube />
              </SocialButton>
              <SocialButton label={'Instagram'} href={'#'}>
                <FaInstagram />
              </SocialButton>
            </Stack>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Tentang Pabryk University</ListHeader>
            <Link href={'#'}>university.pabryk.com</Link>
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Jadi Mitra</ListHeader>
            <HStack>
              <IconButton
                  bg={useColorModeValue('#6554C0.400', '#6554C0.800')}
                  fontSize={'xl'}
                  color={useColorModeValue('white', 'gray.800')}
                  _hover={{
                    bg: '#white.900',
                  }}
                  aria-label="Subscribe"
                  icon={<BsFillEnvelopeFill />}
                />
                <Link href={'#'}>pabryku@gmail.com</Link>
            </HStack>
            
          </Stack>
          <Stack align={'flex-start'}>
            <ListHeader>Subscribe</ListHeader>
            <Stack direction={'row'}>
              <Input
                placeholder={'Your email address'}
                bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
                border={0}
                maxWidth={'100%'}
                _focus={{
                  bg: 'whiteAlpha.300',
                }}
              />
              <IconButton
                bg={useColorModeValue('#FFFFFF')}
                color={useColorModeValue('#6554C0')}
                _hover={{
                  bg: '#6554C0',
                  color: '#FFFFFF'
                }}
                aria-label="Subscribe"
                icon={<BiMailSend />}
              />
            </Stack>
            <br></br>
          <ListHeader>
            <Link  href={'https://wa.me/6282273399093'} style={{textDecoration: 'none'}}>
              <Button style={{background: '#FFFFFF', color: '#6554C0', border: '2px solid #6554C0'}}>Bantuan</Button>
            </Link>
          </ListHeader>
          </Stack>
          
          
        </SimpleGrid>
      </Container>
    </Box>
  );
}